import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import solution1 from "../images/icon-solutions-01.svg";
import solution2 from "../images/icon-solutions-02.svg";
import solution3 from "../images/icon-solutions-03.svg";
import solution4 from "../images/icon-solutions-04.svg";
import award1 from "../images/icon-award-01.svg";
import award2 from "../images/icon-award-02.svg";
import award3 from "../images/icon-award-03.svg";
import award4 from "../images/icon-award-04.svg";
import Visa from "../images/logo-visa.svg";
import Mastercard from "../images/logo-mastercard.svg";
import Neteller from "../images/logo-neteller.svg";
import Paysafe from "../images/logo-paysafecard.svg";
import Skrill from "../images/logo-skrill.svg";
import Trustly from "../images/logo-trustly.svg";
import Evolotion from "../images/logo-evolotion-gaming.svg";
import Netent from "../images/logo-netent.svg";
// import Microgaming from "../images/logo-microgaming.svg";
import Playson from "../images/logo-playson.svg";
import Yggdrasil from "../images/partners/yggdrasil.svg";
// import Pragmatic from "../images/partners/pragmatic-play.svg";
import RedTiger from "../images/partners/redtiger.svg";
import GreenTube from "../images/partners/greentube.svg";
import HeroBanner from "./HeroBanner";

class Home extends Component {
  componentDidMount() {
    document.getElementById("root").classList.add("welcome");
    document.getElementById("root").classList.remove("affiliate");
    document.getElementById("foo").classList.remove("overflow");
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>STech - The Art Of Technology</title>
          <meta
            name="description"
            content="STech The expert on Platform & The Art Of Technology"
          />
        </Helmet>
        <HeroBanner />

        <section className="clearfix fadeInUp">
          <div className="container">
            <div className="row">
              <div className="col">
                <img
                  src={solution4}
                  title="The Platform Solution"
                  alt="The Platform Solution"
                />
                <div>
                  <h2>The Platform Solution</h2>
                  <p>
                    The STech platform is one of a kind. A fast, secure and
                    scalable platform built for the future.
                  </p>
                  <Link to="/product/the-platform-solution" className="btn">
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>
              <div className="col">
                <img
                  src={solution2}
                  title="Powerful Products & Partners"
                  alt="Powerful Products & Partners"
                />
                <div>
                  <h2>Powerful Products & Partners</h2>
                  <p>
                    Quality is one of the major cornerstones for us at STech
                    Technology.
                  </p>
                  <Link
                    to="/product/powerful-products-and-partners"
                    className="btn"
                  >
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <img
                  src={solution1}
                  title="Omni-Channel is key"
                  alt="Omni-Channel is key"
                />
                <div>
                  <h2>Omni-Channel is key</h2>
                  <p>
                    A key for any brand is to give the customer a seamless and
                    effective path in the relationship with your brand.
                  </p>
                  <Link to="/product/omni-channel" className="btn">
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>
              <div className="col">
                <img
                  src={solution3}
                  title="Marketing &amp; Operational Services"
                  alt="Marketing &amp; Operational Services"
                />
                <div>
                  <h2>Marketing &amp; Operational Services</h2>
                  <p>
                    Our team of experts have decades of experience and knowledge
                    from the industry and will guide you right...
                  </p>
                  <Link
                    to="/product/marketing-operational-services"
                    className="btn"
                  >
                    <span>Learn More</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="clearfix fadeInUp">
          <div className="container">
            <h4>This is us</h4>
            <h1>Win with the STech Platform</h1>
            <p>
              STech is a hi-tech, fast-paced company but above all we aim to
              create business partnerships that grow over time. Our platform,
              our technology, our smart prices and business models promise to
              beat all competition.
            </p>
            <ul className="row">
              <li>
                <img
                  src={award1}
                  title="Casino & Sports Betting"
                  alt="Casino & Sports Betting"
                />
                <p>Casino &amp; Sports Betting</p>
              </li>
              <li>
                <img
                  src={award3}
                  title="Platform Building"
                  alt="Platform Building"
                />
                <p>Platform Building</p>
              </li>
              <li>
                <img
                  src={award2}
                  title="Social Innovation and IP in Social Tools and Products"
                  alt="Social Innovation and IP in Social Tools and Products"
                />
                <p>Social Innovation and IP in Social Tools and Products</p>
              </li>
              <li>
                <img
                  src={award4}
                  title="The International Outlook"
                  alt="The International Outlook"
                />
                <p>The International Outlook</p>
              </li>
            </ul>
          </div>
        </section>

        <section className="clearfix fadeInUp">
          <div className="container">
            <h1>
              We Create Powerful <br />
              Partnerships
            </h1>
            <p>Meet just a few of our global portfolio of over 20+ clients</p>
            <div className="providers abc">
              <h1>Payment Providers</h1>
              <img src={Visa} alt="Visa" title="Visa" />
              <img src={Mastercard} alt="Mastercard" title="Mastercard" />
              <img src={Neteller} alt="Neteller" title="Neteller" />
              <img src={Paysafe} alt="Paysafe" title="Paysafe" />
              <img src={Skrill} alt="Skrill" title="Skrill" />
              <img src={Trustly} alt="Trustly" title="Trustly" />
            </div>
            <div className="providers">
              <h1>Game Providers</h1>
              <img
                src={Evolotion}
                alt="Evolotion Gaming"
                title="Evolotion Gaming"
              />
              <img src={Netent} alt="Netent" title="Netent" />
              {/* <img src={Microgaming} alt="Microgaming" title="Microgaming" /> */}
              <img src={Playson} alt="Playson" title="Playson" />
              <img src={Yggdrasil} alt="Yggdrasil" title="Yggdrasil" />
              {/* <img src={Pragmatic} alt="Pragmatic Play" title="Pragmatic Play" /> */}
              <img src={GreenTube} alt="Green Tube" title="Green Tube" />
              <img src={RedTiger} alt="Red Tiger" title="Red Tiger" />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    posts: state.posts.items,
    loading: state.posts.loading,
    error: state.posts.error
  };
};

export default connect(mapStateToProps)(Home);
